document.addEventListener('DOMContentLoaded', () => {
  findProgramWidget();
});

function findProgramWidget() {
  document.querySelectorAll('.js-find-program-widget').forEach((element) => {
    const button = element.querySelector('.find-program-widget__button');
    const gradeSelect = element.querySelector('#current_grade');
    const typeSelect = element.querySelector('#program_type');

    if (!button || !gradeSelect || !typeSelect) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();

      const url = new URL(button.getAttribute('href'), window.location.origin);

      const grade = gradeSelect.value;
      const type = typeSelect.value;

      if (grade) {
        url.searchParams.set('grade', grade);
      }

      if (type) {
        url.searchParams.set('program_type', type);
      }

      window.location.href = url.toString();
    });
  });
}
